// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"c2c2a379","960":"c2c2a379"}[chunkId] + ".chunk.css";
};